import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface buildrModalProps {
    isOpen: boolean;
}
const initialState: buildrModalProps = {
    isOpen: false,
};
const buildrModalSlice = createSlice({
    name: 'buildrModal',
    initialState,
    reducers: {
        setBuildrModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setBuildrModalOpen } = buildrModalSlice.actions;
export default buildrModalSlice.reducer;
